export default {
  topRow: {
    display: 'flex',
    columnGap: '1rem',
    alignItems: 'center',
    mb: '.5rem',
    p: '0 2rem'
  }
};
